import React from "react";
import ChatbotIconImg from "../../images/chatbot-icon.png";
import CoPayLoginModal from "../modal/CoPayLoginModal";
import useModal from "../modal/useModal";

const Chatbot = () => {
  const { isShowing, toggle } = useModal();
  return (
    <>
    <CoPayLoginModal isShowing={isShowing} hide={toggle} pageToRedirect="/chatbot" page="isChatbot" />
      <div className="card bg-turquoise rounded-0 border-0 text-center p-4">
        <div className="entry-title">
          <img src={ChatbotIconImg} alt="" className="img-fluid entry-icon" />
          <h3 className="fw-bold text-white mt-2">Chatbot</h3>
        </div>
        <div className="entry-btn mt-auto">          
          <a
            className="btn btn-outline-white btn-default fs-18 text-uppercase"
            onClick={(e) => {
              e.preventDefault();
              toggle();
            }}
            href="#"
          >
            Enter
          </a>
        </div>
      </div>
    </>
  );
};
export default Chatbot;
